/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { Waiting } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

export interface IPaymentWaitingProps {
    message: string;
}

const PaymentWaiting: React.FC<IPaymentWaitingProps> = ({ message }) => (
    <div className='ms-checkout-payment-instrument__loading-background'>
        <Waiting />
        <span className='ms-checkout-payment-instrument__loading-message'>
            {message}
        </span>
    </div>
);

export default PaymentWaiting;
